<template>
<main v-if="!loading">
  <div class="container">
    <h3>Table of Note</h3>
    <hr />
    <table class="table table-hover table-responsive table-striped">
      <thead class="thead thead-dark">
        <tr>
          <th>Title</th>
          <th>Subject</th>
          <th>Published</th>
          <th>Action</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody class="shadow-lg">
        <tr v-for="note in notes" :key="note.id">
          <td>
            <router-link
              :to="{
                name: 'notes.show',
                params: { noteSlug: note.slug },
              }"
              >{{ note.title }}</router-link
            >
          </td>
          <td>{{ note.subject }}</td>
          <td>{{ note.published }}</td>
          <td>
            <router-link
              :to="{
                name: 'notes.edit',
                params: { noteSlug: note.slug },
              }"
               class="badge badge-warning">Edit</router-link
            >
          </td>
          <td>
            <delete-note :endpoint="note.slug" />
          </td>
        </tr>
        
      </tbody>
    </table>
    
  
     </div>
     
  </main>

 <main class="container" v-else>
    <p class="h1">
      Mengambil Data..
    </p>
    <img :src="loadingImage" class="rounded float-left" alt="" />
  </main>

</template>

<script>
// import loadingImage from "./assets/loading.svg"
import axios from "axios";
import DeleteNote from "./Delete";
export default {
  components: {
    DeleteNote,
  },
  data() {
    return {
      loading: true,
      notes: [],
      loadingImage: require("@/assets/loading.svg"),
      // loadingImage: loadingImage,
    };
  },

  mounted() {
    // axios.get("/api/notes").then(response => {
    //     this.notes = response.data.data;
    //     // console.log(response.data.data);
    // });
    // const data = await res.json();
    // return data;
    this.getNotes();
  },

  methods: {
    async getNotes() {
      this.loading = true;
      // let response = await await axios.get("/api/notes");
      // this.notes = response.data.data;
      let { data } = await await axios.get("/api/notes");
      this.notes = data.data;
      this.loading = false;
    },
  },
};
</script>
